const PRODUCT_NAME = 'Primum';

/** The browser tab's title for a page: "Page · Primum", or the product alone. */
export function documentTitle(page?: string): string {
  return page ? `${page} · ${PRODUCT_NAME}` : PRODUCT_NAME;
}
